import { FC, ReactElement } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { Drawer } from '../../common';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';

interface NotificationFilterOrderStatusDrawerProps {
  children: ReactElement | ReactElement[];
  drawerProps: object;
  closeDrawer: () => void;
  OrderStatusFilterTitle: string;
  backButtonAriaLable: string;
}

export const NotificationFilterOrderStatusDrawer: FC<
  NotificationFilterOrderStatusDrawerProps
> = ({
  drawerProps,
  OrderStatusFilterTitle,
  closeDrawer,
  children,
  backButtonAriaLable
}) => {
  return (
    <Drawer
      {...drawerProps}
      onBlDrawerClose={closeDrawer}
      data-testid="orderstatus-drawer"
    >
      <div slot="header" className="d-flex align-items-center">
        <CatButton
          hideText
          onClick={() => closeDrawer()}
          size="sm"
          variant="ghost"
        >
          <CatIconArrowBack slot="before" aria-label={backButtonAriaLable} />
        </CatButton>
        <CatHeading
          variant="title-sm"
          id="notification-filters-header"
          className="ms-3"
          aria-label={OrderStatusFilterTitle}
        >
          {OrderStatusFilterTitle}
        </CatHeading>
      </div>
      {children}
    </Drawer>
  );
};
